import axios from 'axios';

// export const BASE_URL = 'http://127.0.0.1:8000/';
export const BASE_URL = 'https://mysite-dtzs.onrender.com/';
const PRODUCT_URL = `${BASE_URL}products/`;
const CATEGORY_URL = `${BASE_URL}categories/`;
const LOGOUT_URL = `${BASE_URL}logout/`;
const LOGIN_URL = `${BASE_URL}login/`;
const REGISTER_URL = `${BASE_URL}register/`;
const AUTHENTICATED_URL = `${BASE_URL}authenticated/`;
const PASSWORD_RESET_URL = `${BASE_URL}api/request-reset/`;
const USER_ORDERS_URL = `${BASE_URL}my-orders/`; 
const USER_INFO_URL = `${BASE_URL}api/user-info/`;

axios.defaults.withCredentials = true;

export const getProductById = async (id) => {
  try {
    const response = await axios.get(`${PRODUCT_URL}${id}/`, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch product by ID:', error);
    throw error;
  }
};

export const createPaynowPayment = async (orderData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/paynow/create/`,
      orderData,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Handle updated backend format using `poll_url`
    if (response.data && response.data.poll_url) {
      return {
        paymentUrl: response.data.poll_url, // remap to expected name
        ...response.data,
      };
    } else {
      throw new Error("Unexpected Paynow response format");
    }
  } catch (error) {
    console.error("Paynow payment creation failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("Paynow payment creation failed");
  }
};





export const getUserInfo = async () => {
  try {
    const response = await axios.get(USER_INFO_URL, { withCredentials: true });
    return response.data;  // { username, first_name, last_name, email, etc. }
  } catch (error) {
    console.error("Failed to fetch user info:", error);
    throw error;
  }
};


export const createOrder = async (orderData) => {
  try {
    const response = await axios.post(`${BASE_URL}orders/`, orderData, { withCredentials: true });
    return response.data;  // The saved order data or confirmation
  } catch (error) {
    console.error("Order creation failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("Order creation failed");
  }
};




export const getUserOrders = async () => {
  try {
    const response = await axios.get(USER_ORDERS_URL, { withCredentials: true });
    console.log("User Orders:", response.data); // 👈 log here
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user orders:", error.response?.data || error.message);
    throw error.response?.data || new Error("Fetching user orders failed");
  }
};



export const passwordResetRequest = async (email) => {
  try {
    const response = await axios.post(
      PASSWORD_RESET_URL,
      { email },
      { withCredentials: true }
    );
    return response.data;  // Usually a success message or empty object
  } catch (error) {
    console.error("Password reset request failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("Password reset failed");
  }
};


// Get all products (with categories and images)
export const getProducts = async () => {
    try {
        const response = await axios.get(PRODUCT_URL, { withCredentials: true });
        console.log("API Products Response:", response.data); // Add this line
        return response.data;
    } catch (error) {
        console.error("Failed to fetch products:", error);
        return [];
    }
};

export const login = async (username, password) => {
  const response = await axios.post(
    LOGIN_URL,
    { username, password },
    { withCredentials: true }
  );
  return response.data; // let the caller handle success
};



export const register = async (username, first_name, phone_number, last_name, city, address, email, password) => {
  const response = await axios.post(REGISTER_URL,
    { username, first_name, phone_number, last_name, city, address, email, password },
    { withCredentials: true }
  );
  return response.data;
};


export const logout = async () => {
    const response = await axios.post(LOGOUT_URL, { withCredentials: true });
    return response.data;
};
export const getCategories = async () => {
    try {
        const response = await axios.get(CATEGORY_URL, { withCredentials: true });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch categories:", error);
        return [];
    }
};


export const verifyPayPalOrder = async (orderID, orderData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/paypal-verify/`,
      {
        orderID,
        orderData,
      },
      { withCredentials: true }
    );
    return response.data;  // success message
  } catch (error) {
    console.error("PayPal verification failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("PayPal verification failed");
  }
};


export const authenticated_user = async () => {
    const response = await axios.get(AUTHENTICATED_URL, { withCredentials: true });
    return response.data
}



export const createReview = async (reviewData) => {
  try {
    const response = await axios.post(`${BASE_URL}api/reviews/create/`, reviewData, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Review creation failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("Review creation failed");
  }
};

export const getReviews = async (username = '') => {
  try {
    const url = username ? `${BASE_URL}api/reviews/?username=${username}` : `${BASE_URL}api/reviews/`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch reviews:", error.response?.data || error.message);
    throw error.response?.data || new Error("Failed to fetch reviews");
  }
};


export const updateReview = async (id, updatedData) => {
  try {
    const response = await axios.put(
      `${BASE_URL}api/reviews/${id}/update/`,
      updatedData,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error("Review update failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("Review update failed");
  }
};


export const deleteReview = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}api/reviews/${id}/delete/`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Review deletion failed:", error.response?.data || error.message);
    throw error.response?.data || new Error("Review deletion failed");
  }
};


const SUPPLIER_ORDERS_URL = `${BASE_URL}supplier-orders/`;

export const getSupplierOrders = async () => {
  try {
    const response = await axios.get(SUPPLIER_ORDERS_URL, { withCredentials: true });
    console.log("Supplier Orders:", response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch supplier orders:", error.response?.data || error.message);
    throw error.response?.data || new Error("Fetching supplier orders failed");
  }
};
